<template>
	<a
		v-bind="$attrs"
		v-on="listeners"
		class="Button"
		href="javascript: void(0)"
		:style="color ? { '--color': color } : {'--color': 'var(--clrTheme)' }"
		:class="{ disabled }"
		@click="onClick"
	>
		<i v-if="icon" :class="{ [`icon-${icon}`]: !!icon }"></i>
		<slot></slot>
	</a>
</template>

<script>
	export default {
		props: {
			icon: {
				type: String
			},
			disabled: {
				type: Boolean,
				default: false
			},
			color: {
				type: String,
			}
		},
		methods: {
			onClick(...args) {
				if (!this.disabled && !this.loading) {
					this.$emit('click', ...args);
				}
			}
		},
		computed: {
			listeners() {
				const { click, ...rest } = this.$listeners;
				return rest;
			}
		}
	};
</script>

<style scoped lang="scss">
	.Button {
		background-color: var(--color, var(--clrTheme1));
		color: white;
		padding: 1rem 2rem;
		display: inline-flex;
		align-items: center;
		justify-content: center;
		border-radius: 0.5rem;
		cursor: pointer;
		white-space: nowrap;
		transition: all 0.2s;

		&.disabled {
			background-color: var(--clrFaded);
			cursor: not-allowed;
		}

		&:not(.disabled) {
			&:hover, &:active {
				background-color: var(--clrTheme2);
			}
		}

		i {
			margin-right: 1rem;
			font-size: 1.33em;
		}
	}
</style>
